<template>
  <div>
    <breadcrumb></breadcrumb>
    <con-title>成功案例</con-title>
    <div class="con w">
      <el-row :gutter="30" style="margin-bottom:30px;">
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/武汉市爱之家汽车服务有限公司.png" alt="" />
            <span>武汉市爱之家汽车服务有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/湖南中南二手车工程机械交易管理有限公司.jpg" alt="" />
            <span>湖南中南二手车工程机械交易管理有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/浙江途众汽贸控股有限公司.png" alt="" />
            <span>浙江途众汽贸控股有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/苏州恩加壹汽车服务有限公司.jpg" alt="" />
            <span>苏州恩加壹汽车服务有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/枣庄中安旧机动车交易市场有限公司.jpg" alt="" />
            <span>枣庄中安旧机动车交易市场有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/南京大公二手车交易中心有限公司.jpg" alt="" />
            <span>南京大公二手车交易中心有限公司</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30" style="margin-bottom:30px;">
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/太原旧机动车交易中心（有限公司）.jpg" alt="" />
            <span>太原旧机动车交易中心（有限公司）</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/南宁新畅行汽车市场管理有限公司.jpg" alt="" />
            <span>南宁新畅行汽车市场管理有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/沈阳好车芝嘛科技有限公司.png" alt="" />
            <span>沈阳好车芝嘛科技有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/新疆天汇华尚二手车交易有限公司.jpg" alt="" />
            <span>新疆天汇华尚二手车交易有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/九江二手车市场有限公司.png" alt="" />
            <span>九江二手车市场有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/南通三六五二手车交易市场有限公司.jpg" alt="" />
            <span>南通三六五二手车交易市场有限公司</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30" style="margin-bottom:30px;">
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/昆山华丰旧机动车交易市场有限公司.jpg" alt="" />
            <span>昆山华丰旧机动车交易市场有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/连云港旧机动车交易市场有限公司.png" alt="" />
            <span>连云港旧机动车交易市场有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/聊城万晟二手车交易市场.png" alt="" />
            <span>聊城万晟二手车交易市场</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/衢州市旧机动车辆交易中心有限责任公司.jpg" alt="" />
            <span>衢州市旧机动车辆交易中心有限责任公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/苏州瑞尚汽车交易市场有限公司.png" alt="" />
            <span>苏州瑞尚汽车交易市场有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/苏州市旧机动车交易市场有限公司.jpg" alt="" />
            <span>苏州市旧机动车交易市场有限公司</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30" style="margin-bottom:30px;">
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/宿迁国际汽车城产业发展有限公司.png" alt="" />
            <span>宿迁国际汽车城产业发展有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/潍坊联运有限责任公司.jpg" alt="" />
            <span>潍坊联运有限责任公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/芜湖斑马汽车城.jpg" alt="" />
            <span>芜湖斑马汽车城</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/义乌市汇商汽车发展有限公司.jpg" alt="" />
            <span>义乌市汇商汽车发展有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/榆林东信二手车交易市场有限公司.jpg" alt="" />
            <span>榆林东信二手车交易市场有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/中国铁路西安局有限公司.jpg" alt="" />
            <span>中国铁路西安局有限公司</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30" style="margin-bottom:30px;">
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/浙江元通二手车有限公司.png" alt="" />
            <span>浙江元通二手车有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/无锡玖城二手车交易市场有限公司.png" alt="" />
            <span>无锡玖城二手车交易市场有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/大同市海域房地产开发有限责任公司.png" alt="" />
            <span>大同市海域房地产开发有限责任公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/成都宏盟二手车交易市场管理有限公司.png" alt="" />
            <span>成都宏盟二手车交易市场管理有限公司</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="logo-box">
            <img src="../../assets/logo/保定市腾运旧机动车交易市场股份有限公司.jpg" alt="" />
            <span>保定市腾运旧机动车交易市场股份有限公司</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.con {
  padding-top: 40px;
  .logo-box {
    height: 120px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    img {
      width: 80%;
      height: 60%;
      object-fit: contain;
    }
    span {
      color: #888;
      text-align: center;
      font-size: 12px;
      height: 30px;
      padding: 0 10px;
    }
  }
}
</style>
